export default '6.5.2';
